import styled from "styled-components";
import Layout from "../../../components/custom/Layout";
import { IUser, SupportTicket } from "../../../globals/interfaces";
import TicketCard from "./TicketCard";
import { useEffect, useState } from "react";
import _ from "lodash";
import useSupportTickets from "./useSupportTickets";
import { TabContent } from "reactstrap";
import CustomTabPane from "../../../components/custom/CustomTabPane";
import CustomNavItem from "../../../components/custom/CustomNavItem";
import { Nav } from "reactstrap";
import useUser from "../../../customHooks/useUser";
import VirtualTable from "../../../components/custom/VirtualTable";
import { formatEmail } from "../../../utils";
import { useSetRecoilState } from "recoil";
import { selectedTicketIdState, supportRequestModalState } from "./atoms";

export type Tab = 'MANAGE_TICKETS';

export default function ManageTickets() {

    const { user } = useUser();

    const {
        supportTickets: data
    } = useSupportTickets(user.s_email, `/support-ticket?unit=${user.s_unit}`, false);

    const [activeTab, setActiveTab] = useState<Tab>('MANAGE_TICKETS');

    const toggleTab = (tab: Tab) => setActiveTab(tab);

    const setTickedId = useSetRecoilState(selectedTicketIdState);
    const setSupportRequestModal = useSetRecoilState(supportRequestModalState);

    const viewTicket = (item: SupportTicket) => {
        setTickedId(item.id);
        setSupportRequestModal(true);
    }


    return (
        <Layout>
            <Nav tabs className={'separator-tabs'}>
                <CustomNavItem<Tab>
                    tabName="Manage Tickets"
                    tabId="MANAGE_TICKETS"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
            </Nav>
            <TabContent activeTab={activeTab} className={'mt-2'}>
                <CustomTabPane<Tab> tabId={'MANAGE_TICKETS'}>
                    <VirtualTable 
                        data={data}
                        mapping={[{
                            name: 'Created at',
                            value: 'createdAt'
                        }, {
                            name: 'Created by',
                            value: 'createdBy'
                        }, {
                            name: 'Description',
                            value: 'description'
                        }, {
                            name: 'Type',
                            value: 'type'
                        }, {
                            name: 'Assigned to',
                            value: 'assignedTo',
                            email: true
                        }]}
                        handleClick={viewTicket}
                    />
                    {/* <FlexContainer>
                        <RenderTickets tickets={data} user={user} status={'OPEN'} title={'Pending'} />
                        <RenderTickets tickets={data} user={user}  status={'IN PROGRESS'} title={'In Progress'} />
                    </FlexContainer> */}
                </CustomTabPane>
            </TabContent>
        </Layout>
    );
}

const RenderTickets = ({
    tickets,
    status,
    title,
    user
}: {
    tickets: Array<SupportTicket>;
    status: string;
    title: string;
    user: IUser;
}) => {
    const filtered = tickets.filter(ticket => ticket.status === status);
    return (
        <OuterContainer>
            <h4>{title}</h4>
            <TicketsContainer>
                {
                    filtered.map((item) => (<TicketCard item={item} user={user} key={item.id} />))
                }
            </TicketsContainer>
        </OuterContainer>

    );
}

const FlexContainer = styled.div`
    display: flex;
    gap: 20px;
    height: 100%;
`;

const OuterContainer = styled.div`
    flex: 1;
    border: 2px solid black;
    border-radius: 10px;
    height: 92%;
    padding: 10px;
    overflow-y: scroll;
`;

const TicketsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
`;

export const getUnreadMessagesCount = (item: SupportTicket, user: IUser) => {
    if (item.createdBy !== user.s_email) return 0;
    const unreadMessagesCount = item.ticketCommunication ? item.ticketCommunication.reduce((total, current) => {
        if ((_.get(current, 'viewStatus.viewed', true) === false)) {
            total++;
        }
        return total;
    }, 0) : 0;
    return unreadMessagesCount;
}